export const halloweenTheme = {
    primary: "#29b978",
    accent: "#ff7a16",
    background: "#071015",
    card: "#fff8e8",
    text: "#111815",
    mutedText: "#5d625e",
    buttonText: "#ffffff",
    progress: "#45d894",
    border: "#b7b29f",
    radius: "8px",
    fontFamily: "Manrope, ui-sans-serif, system-ui, sans-serif",
    headlineScale: 1,
    bodyScale: 1,
    spacingDensity: "compact",
    answerWeight: 600
};
